import { render, staticRenderFns } from "./FeatureSubscription.vue?vue&type=template&id=35cbc683&scoped=true"
import script from "./FeatureSubscription.vue?vue&type=script&lang=js"
export * from "./FeatureSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cbc683",
  null
  
)

export default component.exports